import React, { useCallback, useEffect, useState } from 'react';

import TaskInfo from './TaskInfo';
import { useAppSelector } from 'store/hooks';
import Registered from '../RegisterResult/Registered';
import ShowTasks from '../RegisterResult/ShowTasks';
import { MyEntry } from 'api/raffle/raffle_detail';

interface ITasksProps {}

const Tasks: React.FC<ITasksProps> = ({}) => {
  const {
    raffleInfo: { status, my_entry },
    raffleRegisterResult: { validation },
  } = useAppSelector((state) => state.raffleDetails);
  const [raffleStatus, setRaffleStatus] = useState('');
  const [myRaffleEntry, setMyRaffleEntry] = useState<MyEntry>();

  useEffect(() => {
    setRaffleStatus(String(status));
    setMyRaffleEntry(my_entry);
  }, [my_entry, status]);

  const drawStatus = useCallback(() => {
    if (!myRaffleEntry && !validation) {
      return (
        <div className=" rounded-2xl border border-neutral-600 px-5 py-6">
          <TaskInfo></TaskInfo>
        </div>
      );
    } else {
      return (
        <div className=" rounded-2xl border border-neutral-600 px-5 py-6">
          <Registered />
          <ShowTasks />
        </div>
      );
    }
  }, [myRaffleEntry, validation]);

  if (raffleStatus === 'ENDED' || raffleStatus === 'FINALIZED') {
    return null;
  }

  return <div>{drawStatus()}</div>;
};

export default Tasks;
